<h2 *ngIf="this.pageName == 'deleteAccount' " mat-dialog-title>શું તમે ખરેખર ખાતું કાઢી નાખવા માંગો છો?</h2>
<h2 *ngIf="this.pageName == 'deletecity' " mat-dialog-title>શું તમે ખરેખર શહેર કાઢી નાખવા માંગો છો?</h2>
<h2 *ngIf="this.pageName == 'activemember' " mat-dialog-title>શું તમે ખરેખર સભ્ય ને માન્ય કરવા માંગો છો?</h2>
<h2 *ngIf="this.pageName == 'manualInviteMember' " mat-dialog-title>શું તમે ખરેખર સભ્યોની હાજરી ભરવા માંગો છો?</h2>
<h2 *ngIf="this.pageName == 'activistmemember' " mat-dialog-title>શું તમે સભ્ય ને કાર્યકર્તા કરવા માંગો છો?</h2>
<h2 *ngIf="this.pageName == 'JobList' " mat-dialog-title>શું તમને ખાતરી છે?</h2>

<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="true">હા</button>
  <button mat-button [mat-dialog-close]="false">ના</button>
</div>

<mat-dialog-content class="text-align-center">
  <div *ngIf="pageName === 'showQr'" class="qr-container text-center">
    <img height="200" #imageElement [src]="QRCode + sub_event_member_id" />
  </div>
</mat-dialog-content>
<!-- <mat-dialog-actions>
  <button mat-button (click)="onNoClick(0)" [hidden]="pageName == 'showQr'">ના આભાર</button>
  <button class="btn-common" (click)="onNoClick(1)" [hidden]="pageName == 'showQr'">
    બરાબર</button>
    <button class="btn-common" (click)="downloadImage()" [hidden]="pageName == 'showQr'" >
     QR ડાઉનલોડ કરો</button>
</mat-dialog-actions> -->
<!-- *ngIf="pageName == 'showQr'" -->